<div class="container">
	<!-- ABA 1: Escolha a cesta -->
	<ng-container *ngIf="!isFormVisible && !isOrderSuccess && !isLoading">
		<h1 class="title">Escolha a cesta que deseja receber</h1>
		<ng-container *ngIf="baskets.length > 0">
			<ng-container *ngFor="let basket of baskets; let i = index; let last = last">
				<!-- Card -->
				<label class="basket-card" (click)="onSelectBasket(basket._id)">
					<img [src]="basket.imagePath" alt="basket image" />

					<div class="basket-card-content">
						<h2 class="basket-card-title">{{ basket.title }}</h2>

						<p class="basket-card-description">
							{{
								expandedBasketIds.has(basket._id)
									? basket.descriptionLong
									: basket.description
							}}
						</p>

						<a
							href=""
							class="basket-card-show-more"
							(click)="toggleDescription($event, basket._id)"
							*ngIf="basket.descriptionLong !== ''"
						>
							{{ expandedBasketIds.has(basket._id) ? 'Ver menos' : 'Ver mais' }}
						</a>
					</div>

					<input type="radio" [checked]="basket._id === selectedBasketId" />
					<span class="radio"></span>
				</label>

				<!-- Custom divisor -->
				<div class="custom-divisor" *ngIf="!last">
					<ui-common-divisor />
					<p class="text">ou</p>
				</div>
			</ng-container>
		</ng-container>

		<!-- Suggest -->
		<!-- <div class="suggest">
			<p>
				Ou se preferir,
				<a [routerLink]="'/indicar-restaurante'">indique um restaurante</a>
			</p>
		</div> -->
	</ng-container>

	<!-- ABA 2: Formulário -->
	<ng-container *ngIf="isFormVisible && !isOrderSuccess && !isLoading">
		<form [formGroup]="userForm">
			<h2 class="title">Dados pessoais</h2>
			<!-- Nome -->
			<div class="form-field">
				<input
					type="text"
					id="name"
					class="form-field__input"
					formControlName="name"
					(focus)="getFieldState('name').setFocused(true)"
					(blur)="getFieldState('name').setFocused(false)"
					[ngClass]="{
						focused: getFieldState('name').focused(),
						filled: userForm.controls.name.value,
						editing: getFieldState('name').editing(),
						error: userForm.controls.name.errors && userForm.controls.name.dirty
					}"
				/>
				<label for="name" class="form-field__label">Nome</label>
				<span class="form-field__underline"></span>
				<div class="error-container">
					@if (userForm.controls.name.errors?.['required'] && userForm.controls.name.dirty) {
						<span class="error-message">Nome é obrigatório</span>
					}
				</div>
			</div>

			<!-- Telefone -->
			<div class="form-field">
				<input
					type="text"
					id="phone"
					class="form-field__input"
					formControlName="phone"
					(focus)="getFieldState('phone').setFocused(true)"
					(blur)="getFieldState('phone').setFocused(false)"
					[ngClass]="{
						focused: getFieldState('phone').focused(),
						filled: userForm.controls.phone.value,
						editing: getFieldState('phone').editing(),
						error: userForm.controls.phone.errors && userForm.controls.phone.dirty
					}"
				/>
				<label for="phone" class="form-field__label">Telefone</label>
				<span class="form-field__underline"></span>
				<div class="error-container">
					@if (userForm.controls.phone.errors?.['required'] && userForm.controls.phone.dirty) {
						<span class="error-message">Telefone é obrigatório</span>
					}
				</div>
			</div>

			<!-- CPF -->
			<div class="form-field">
				<input
					type="text"
					id="cpf"
					class="form-field__input"
					formControlName="cpf"
					(focus)="getFieldState('cpf').setFocused(true)"
					(blur)="getFieldState('cpf').setFocused(false)"
					[ngClass]="{
						focused: getFieldState('cpf').focused(),
						filled: userForm.controls.cpf.value,
						editing: getFieldState('cpf').editing(),
						error: userForm.controls.cpf.errors && userForm.controls.cpf.dirty
					}"
				/>
				<label for="cpf" class="form-field__label">CPF</label>
				<span class="form-field__underline"></span>
				<div class="error-container">
					@if (userForm.controls.cpf.errors?.['required'] && userForm.controls.cpf.dirty) {
						<span class="error-message">CPF é obrigatório</span>
					}
				</div>
			</div>

			<!-- Email -->
			<div class="form-field">
				<input
					type="text"
					id="email"
					class="form-field__input"
					formControlName="email"
					(focus)="getFieldState('email').setFocused(true)"
					(blur)="getFieldState('email').setFocused(false)"
					[ngClass]="{
						focused: getFieldState('email').focused(),
						filled: userForm.controls.email.value,
						editing: getFieldState('email').editing(),
						error: userForm.controls.email.errors && userForm.controls.email.dirty
					}"
				/>
				<label for="email" class="form-field__label">E-mail</label>
				<span class="form-field__underline"></span>
				<div class="error-container">
					@if (userForm.controls.email.errors?.['required'] && userForm.controls.email.dirty) {
						<span class="error-message">E-mail é obrigatório</span>
					}
				</div>
			</div>

			<!-- Endereço -->
			<ui-pm-loading-page *ngIf="isCepLoading" />
			<div class="address" *ngIf="!isCepLoading">
				<h2 class="title">Endereço de entrega</h2>

				<div class="row">
					<!-- CEP -->
					<div class="form-field-bordered">
						<input
							type="text"
							id="zipCode"
							class="form-field-bordered__input"
							formControlName="zipCode"
							(focus)="getFieldState('zipCode').setFocused(true)"
							(blur)="getFieldState('zipCode').setFocused(false)"
							[ngClass]="{
								focused: getFieldState('zipCode').focused(),
								filled: userForm.controls.zipCode.value,
								editing: getFieldState('zipCode').editing(),
								error: userForm.controls.zipCode.errors && userForm.controls.zipCode.dirty
							}"
						/>
						<label for="zipCode" class="form-field-bordered__label">CEP</label>
						<div class="error-container">
							@if (
								userForm.controls.zipCode.errors?.['required'] &&
								userForm.controls.zipCode.dirty
							) {
								<span class="error-message">CEP é obrigatório</span>
							}
						</div>
					</div>

					<!-- Cidade -->
					<div class="form-field-bordered">
						<input
							type="text"
							id="city"
							class="form-field-bordered__input"
							formControlName="city"
							(focus)="getFieldState('city').setFocused(true)"
							(blur)="getFieldState('city').setFocused(false)"
							[ngClass]="{
								focused: getFieldState('city').focused(),
								filled: userForm.controls.city.value,
								editing: getFieldState('city').editing(),
								error: userForm.controls.city.errors && userForm.controls.city.dirty
							}"
						/>
						<label for="city" class="form-field-bordered__label">Cidade</label>
						<div class="error-container">
							@if (
								userForm.controls.city.errors?.['required'] && userForm.controls.city.dirty
							) {
								<span class="error-message">Cidade é obrigatório</span>
							}
						</div>
					</div>

					<!-- Estado -->
					<div class="form-field-bordered">
						<input
							type="text"
							id="state"
							class="form-field-bordered__input"
							formControlName="state"
							(focus)="getFieldState('state').setFocused(true)"
							(blur)="getFieldState('state').setFocused(false)"
							[ngClass]="{
								focused: getFieldState('state').focused(),
								filled: userForm.controls.state.value,
								editing: getFieldState('state').editing(),
								error: userForm.controls.state.errors && userForm.controls.state.dirty
							}"
						/>
						<label for="state" class="form-field-bordered__label">Estado</label>
						<div class="error-container">
							@if (
								userForm.controls.state.errors?.['required'] && userForm.controls.state.dirty
							) {
								<span class="error-message">Estado é obrigatório</span>
							}
						</div>
					</div>
				</div>

				<div class="row">
					<!-- Rua -->
					<div class="form-field-bordered">
						<input
							type="text"
							id="street"
							class="form-field-bordered__input"
							formControlName="street"
							(focus)="getFieldState('street').setFocused(true)"
							(blur)="getFieldState('street').setFocused(false)"
							[ngClass]="{
								focused: getFieldState('street').focused(),
								filled: userForm.controls.street.value,
								editing: getFieldState('street').editing(),
								error: userForm.controls.street.errors && userForm.controls.street.dirty
							}"
						/>
						<label for="street" class="form-field-bordered__label">Rua</label>
						<div class="error-container">
							@if (
								userForm.controls.street.errors?.['required'] &&
								userForm.controls.street.dirty
							) {
								<span class="error-message">Rua é obrigatório</span>
							}
						</div>
					</div>

					<!-- Número -->
					<div class="form-field-bordered">
						<input
							type="text"
							id="number"
							class="form-field-bordered__input"
							formControlName="number"
							(focus)="getFieldState('number').setFocused(true)"
							(blur)="getFieldState('number').setFocused(false)"
							[ngClass]="{
								focused: getFieldState('number').focused(),
								filled: userForm.controls.number.value,
								editing: getFieldState('number').editing(),
								error: userForm.controls.number.errors && userForm.controls.number.dirty
							}"
						/>
						<label for="number" class="form-field-bordered__label">Número</label>
						<div class="error-container">
							@if (
								userForm.controls.number.errors?.['required'] &&
								userForm.controls.number.dirty
							) {
								<span class="error-message">Número é obrigatório</span>
							}
						</div>
					</div>
				</div>

				<!-- Complemento -->
				<div class="form-field-bordered">
					<input
						type="text"
						id="complement"
						class="form-field-bordered__input"
						formControlName="complement"
						(focus)="getFieldState('complement').setFocused(true)"
						(blur)="getFieldState('complement').setFocused(false)"
						[ngClass]="{
							focused: getFieldState('complement').focused(),
							filled: userForm.controls.complement.value,
							editing: getFieldState('complement').editing(),
							error: userForm.controls.complement.errors && userForm.controls.complement.dirty
						}"
					/>
					<label for="complement" class="form-field-bordered__label">Complemento (opcional)</label>
					<!-- <div class="error-container">
							@if (
								userForm.controls.complement.errors?.['required'] && userForm.controls.complement.dirty
							) {
								<span class="error-message">Complemento é obrigatório</span>
							}
						</div> -->
				</div>

				<!-- Aceitação dos termos -->
				<div class="form-field-checkbox">
					<label
						for="terms"
						style="display: flex; align-items: center; justify-content: space-between; gap: 10px"
					>
						<p style="font-weight: 360; font-size: 14px; color: var(--content-txt)">
							Desejo utilizar meu
							<span style="color: var(--content-primary)">benefício celebrations</span>
						</p>
						<input
							type="checkbox"
							id="terms"
							formControlName="acceptedTerms"
							style="width: 18px; height: 18px"
						/>
					</label>
				</div>
			</div>
		</form>

		<div style="height: 150px"></div>
	</ng-container>

	<!-- Order success -->
	<ng-container *ngIf="isOrderSuccess && !isLoading">
		<div
			style="
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				text-align: center;
				gap: 20px;
				height: 80vh;
			"
		>
			<mat-icon svgIcon="pm-icons:check-circle" style="height: 80px; width: 80px"></mat-icon>
			<h1
				class="success-title"
				style="font-weight: 600; font-size: 24px; color: var(--content-primary)"
			>
				Solicitação enviada!
			</h1>
			<p class="success-subtitle" style="font-weight: 360; font-size: 14px; color: var(--content-txt)">
				Enviaremos mais detalhes do seu pedido para o e-mail cadastrado
			</p>
			<button mat-raised-button [routerLink]="'/'">Ver restaurantes</button>
		</div>
	</ng-container>

	<ng-container *ngIf="isLoading">
		<ui-pm-loading-page />
	</ng-container>
</div>
<!-- Buttons -->
<ui-pm-footer-buttons type="fixed-order" *ngIf="!isOrderSuccess && !isLoading">
	@if (!isFormVisible) {
		<button
			mat-raised-button
			[disabled]="selectedBasketId === null"
			(click)="isFormVisible = true"
			class="footer-button"
		>
			Continuar
		</button>
	} @else {
		<button
			mat-raised-button
			(click)="requestBasket()"
			class="footer-button"
			[disabled]="!userForm.valid"
		>
			Solicitar cesta
		</button>
	}
</ui-pm-footer-buttons>
